define.alias("ember-math-helpers/helpers/log2", "media/helpers/log2");